import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit{

  filterGroup!: FormGroup;
  siteList = [
    {id: 1, name: 'abc'},
    {id: 2, name: 'pqr'},
    {id: 3, name: 'suv'},
  ]
  agentList = [
    {id: 1, name: 'covid agent'},
    {id: 2, name: 'phizer agent'},
    {id: 3, name: 'suv'},
  ]

  constructor() {

  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    this.filterGroup = new FormGroup({
      startDate: new FormControl(['']),
      endDate: new FormControl([]),
      site: new FormControl(['']),
      agent: new FormControl([''])
    })
  }

}
